import { jsx } from 'react/jsx-runtime';
import { useComposedRefs } from '@radix-ui/react-compose-refs';
import { Primitive } from '@radix-ui/react-primitive';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useDialogContext } from '../context.mjs';
import { portalContainerStyle } from '../dialog.vanilla.mjs';

const PortalContainer = forwardRef(({ className, ...props }, ref) => {
  const { onPortalContainerElementChange } = useDialogContext(
    "Dialog.PortalContainer"
  );
  const composedRef = useComposedRefs(ref, onPortalContainerElementChange);
  return /* @__PURE__ */ jsx(
    Primitive.div,
    {
      "data-scope": "dialog",
      "data-part": "portal-container",
      ref: composedRef,
      className: classNames(className, portalContainerStyle),
      ...props
    }
  );
});

export { PortalContainer };
//# sourceMappingURL=PortalContainer.mjs.map
